// extracted by mini-css-extract-plugin
export default {"loading-container":"AdminPortalWrapper_loading-container__JeMKg","error-container":"AdminPortalWrapper_error-container__lk2yT"};